import { CategoryFilterId, PeriodFilterId, YearFilterId } from '../../../constants/ids';
import { AirportFile } from '../../../entities/AirportFile';
import {
  yearFileFilterOptionComparer,
  periodFileFilterOptionComparer,
  categoryFileFilterOptionComparer,
} from '../../../utils/filter';
import { periodValuesSelector, yearValuesSelector } from '../../../utils/selector';
import { FileFilterSystemHelper } from '../../fileFilterSystem/helper';
import { FileFilterSystemState } from '../../fileFilterSystem/types';

const periodFilter = FileFilterSystemHelper.generateInitialFileFilter(
  PeriodFilterId,
  'FileExplorer.Filters.Period',
  (file: AirportFile) => file.period,
  periodFileFilterOptionComparer,
  periodValuesSelector,
);

const yearFilter = FileFilterSystemHelper.generateInitialFileFilter(
  YearFilterId,
  'FileExplorer.Filters.Year',
  (file: AirportFile) => file.year,
  yearFileFilterOptionComparer,
  yearValuesSelector,
);

const categoryFilter = FileFilterSystemHelper.generateInitialFileFilter(
  CategoryFilterId,
  'FileExplorer.Filters.Category',
  (file: AirportFile) => file.category,
  categoryFileFilterOptionComparer,
);

export function generateInitialState(): FileFilterSystemState<AirportFile> {
  return {
    filters: [periodFilter, yearFilter, categoryFilter],
    filesMap: {},
    filteredFiles: [],
  };
}
